import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'billStatus': {
    title: '要货状态',
    type: 'select',
    equation: all,
    dictionary: 'wantgoodStatus',
    // defaultVal: 'E002'
  },
  'handleNode': {
    title: '节点',
    type: 'select',
    dictionary: 'handeNode',
    dictionaryVal: [
      { name: '终端直配第一负责人', value: '终端直配第一负责人' },
      { name: '基地经理', value: '基地经理' }
    ]
  },
  'wantCode': {
    title: '要货单编号',
    type: 'input',
    equation: all
  },
  'quotasYear': {
    title: '配额年度',
    type: 'year',
    equation: all
  },
  'createdDate': {
    title: '要货日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'productCode': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  },
  'productDesc': {
    title: '产品描述',
    type: 'input'
  },
  'ZZFLD000016': {
    title: '客户类型',
    type: 'select',
    equation: all,
    dictionary: 'A0009'
  },
  'orderStatus': {
    title: '安吉货运状态',
    type: 'select',
    equation: all,
    dictionary: 'B0101'
  },
  'sendTime': {
    title: '归档日期',
    type: 'date',
    equation: cusname,
    valueFormat: 'yyyy-MM-dd'
  },
  'receiveUnitName': {
    title: '收货终端',
    type: 'input'
  },
  'cycleDate': {
    title: '周期',
    type: 'cycle',
  },
  'remark': {
    title: '备注',
    type: 'input'
  },
}

export default {
  'createdDate': {
    title: '创建日期',
    width: 140
  },
  'wantCode': {
    title: '要货单号',
    slot: true,
    width: 110
  },
  'invoIds': {
    title: '发票号',
    width: 110
  },
  'productDesc': {
    title: '产品',
    width: 400
  },
  'wantQuantity': {
    title: '要货量',
    width: 130,
    xlsxFmt: {
      t: 'n'
    }
  },
  'receiveUnitName': {
    title: '收货终端',
    width: 200
  },
  'contacPerson': {
    title: '收货联系人'
  },
  'contactNumber': {
    title: '收货联系电话'
  },
   'receiveAddress': {
    title: '收货地址',
    width: 300
  },
  'handleNode': {
    title: '节点',
    slot: true,
  },
  'orderStatusTextView': {
    title: '安吉货运状态',
    slot: true,
    width: 110
  },
  'faHuoCode': {
    title: '发运单号',
    width: 120
  },
  'qaz': {
    title: '查看签收图片',
    slot: true,
    width: 110
  },


  // 'remark': {
  //   title: '备注',
  //   width: 250
  // },

  // 'spurtCodeUnitName': {
  //   title: '喷码单位',
  //   width: 200
  // },
  // 'billStatusTextView': {
  //   title: '状态',
  //   width: 90
  // },
  // 'sendTime': {
  //   title: '推送日期',
  //   width: 140
  // },
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/childCustomerList.js